export default "__VITE_ASSET__980eaabb__"